export const todoList = [
    {
        title: '投标',
        icon: 'iconindex_file',
        style: 'color: #63CC00',
        auth: '/index-40',
        list: [
            {
                name: '待购标书项目',
                num: 0,
                path: 'myBidding',
                query: {
                    supplierBidStatusList: '2',
                    bidStatus: '30'
                }
            },
            {
                name: '待报价项目',
                num: 0,
                path: 'myBidding',
                query: {
                    bidStatus: '50'
                }
            },
            {
                name: '待盖章应标文件',
                num: 0,
                path: 'myBidding',
                query: {
                    supplierBidStatusList: '5,6',
                    bidStatus: '30'
                }
            },
            {
                name: '待盖章报价文件',
                num: 0,
                path: 'myBidding',
                query: {
                    supplierBidStatusList: '12,13',
                    bidStatus: '53'
                }
            },
            {
                name: '待缴纳投标保证金',
                num: 0,
                path: 'myBidding',
                query: {
                    supplierBidStatusList: '3',
                    bidStatus: '30'
                }
            }
        ]
    },
    {
        title: '合同',
        icon: 'iconindex_folder',
        style: 'color: #009FFF',
        auth: '/index-50',
        list: [
            {
                name: '待签署合同',
                num: 0,
                path: 'contractSigning',
                query: {
                    contractStatus: '30'
                }
            },
            {
                name: '待支付合同押金',
                num: 0,
                path: 'depositIndex'
            }
        ]
    },
    {
        title: '订单',
        icon: 'iconindex_task',
        style: 'color: #FCBC05',
        refresh: true,
        auth: '/index-60',
        list: [
            {
                name: '待配载-城配',
                num: 0,
                path: 'dispatchCenter',
                query: {
                    transportStatus: '0'
                }
            },
            {
                name: '待配载-大物流',
                num: 0,
                path: 'dispatch',
                query: {
                    ettaStatus: '00'
                }
            },
            {
                name: '待发车-城配',
                num: 0,
                path: 'dispatchOrder',
                query: {
                    dispatchStatuss: '0,10,20,30'
                }
            },
            {
                name: '待发车-大物流',
                num: 0,
                path: 'tmsDispatchOrder',
                query: {
                    etdoStatus: '00,10,20,25'
                }
            },
            {
                name: '待抵达-城配',
                num: 0,
                path: 'dispatchOrder',
                query: {
                    dispatchStatuss: '40'
                }
            },
            {
                name: '待抵达-大物流',
                num: 0,
                path: 'passage',
                query: {
                    etdoStatus: '30'
                }
            },
            {
                name: '待上传回单-城配',
                num: 0,
                path: 'receiptCenter',
                query: {}
            },
            {
                name: '待上传回单-大物流',
                num: 0,
                path: 'receiptManage',
                query: {
                    ettaStatus: '60',
                    mddrElectronicExist: '00'
                }
            }
        ]
    },
    {
        title: '账务',
        icon: 'iconindex_bill',
        style: 'color: #FF8800',
        auth: '/index-70',
        list: [
            {
                name: '待确认对账任务',
                num: 0,
                path: 'costIndex'
            },
            // {
            //     name: '',
            //     num: 0
            // },
            {
                name: '待确认账单',
                num: 0,
                path: 'billIndex',
                query: {
                    billData: '30',
                    fromName: 'index'
                }
            },
            {
                name: '待处理结算申请(新建)',
                num: 0,
                path: 'settleIndex',
                query: {
                    settleData: '10'
                }
            },
            {
                name: '待处理结算申请(驳回)',
                num: 0,
                path: 'settleIndex',
                query: {
                    settleData: '47'
                }
            },
            {
                name: '待处理往来对账单',
                num: 0,
                path: 'statementIndex',
                query: {
                    accountMode: 'A',
                    dealingsBillStatus: '20,30,50'
                }
            },
            {
                name: '待处理发票',
                num: 0,
                path: 'InvoiceManage',
                query: {
                    fromName: 'index'
                }
            }
        ]
    },
    {
        title: '运力',
        icon: 'iconindex_folder',
        style: 'color: #FF5500',
        auth: '/index-80',
        list: [
            {
                name: '运力待建设...',
                num: 0
            }
        ]
    }
    // {
    //     title: '绩效',
    //     icon: 'iconindex_task',
    //     style: 'color: #FF8800',
    //     auth: '/index-90',
    //     list: [
    //         {
    //             name: '待处理日常考核单',
    //             num: 0,
    //             path: 'dayAssessHead',
    //             query: {
    //                 dailyStatus: '1'
    //             }
    //         },
    //         {
    //             name: '待提交整改任务',
    //             num: 0,
    //             path: 'workTask',
    //             query: {
    //                 taskStatus: '1'
    //             }
    //         }
    //     ]
    // }
];

export const FINANCETODO = 'financeTodo';

export const moduleList = [
    {
        code: 'bidNotice',
        isRemove: true,
        label: '招标公告',
        type: 'notice',
        totalCount: 0,
        auth: '/index-srm-120',
        childList: [
            // {
            //     id: "1",
            //     noticeCode: "1",
            //     noticeTitle: "",
            //     updateTime: "2023-01-01 16:31:46",
            //     recommendFlag: true,
            //     readFlag: true
            // }
        ],
        projectTotalCount: 0,
        projectList: []
    },
    {
        code: 'bidTabs',
        isRemove: true,
        label: '我的投标',
        type: 'tabs',
        auth: '',
        childList: [
            {
                code: 'pendingTender',
                label: '已报名待购标书',
                auth: '/index-srm-130',
                num: '',
                iconClass: 'buy-icon',
                unit: '个'
            },
            {
                code: 'bidPaid',
                label: '待缴纳投标保证金',
                auth: '/index-srm-130',
                num: '',
                iconClass: 'bond-icon',
                unit: '个'
            },
            {
                code: 'sealedQuotation',
                label: '待盖章应标文件',
                auth: '/index-srm-130',
                num: '',
                iconClass: 'stamp-icon',
                unit: '个'
            },
            {
                code: 'toQuote',
                label: '待报价',
                auth: '/index-srm-130',
                num: '',
                iconClass: 'quotation-icon',
                unit: '个'
            }
        ]
    },
    {
        code: 'signTabs',
        isRemove: true,
        label: '合同签署',
        type: 'tabs',
        auth: '',
        childList: [
            {
                code: 'pendingContractSigning',
                label: '待签署合同',
                auth: '/index-srm-140',
                num: '',
                iconClass: 'sign-icon',
                unit: '个',
                isRemove: false
            },
            {
                code: 'noPaymentContractDeposit',
                label: '待支付合同押金',
                auth: '/index-bms-170',
                num: '0',
                iconClass: 'payment-icon',
                unit: '个',
                pageParams: {
                    path: '/bms/deposit',
                    query: {
                        from: 'todoList'
                    }
                }
            }
        ]
    },
    {
        label: '运力待办',
        code: 'transportTodo',
        iconClass: 'transport-icon',
        isRemove: true,
        type: 'todo',
        auth: '',
        childList: [
            {
                code: 'driverReview',
                info: '统计当前司机最新一条审批记录的复核状态=复核不通过，且提交人=当前登录账号的司机总数',
                label: '司机复核不通过',
                auth: '/index-srm-150',
                value: '',
                unit: '个'
            },
            {
                code: 'vehicleReview',
                info: '统计当前车辆最新一条审批记录的复核状态=复核不通过，且提交人=当前登录账号的车辆总数',
                label: '车辆复核不通过',
                auth: '/index-srm-150',
                value: '',
                unit: '个'
            },
            {
                code: 'supplierJoinApplyCount',
                label: '司机加入申请',
                auth: '/index-srm-150',
                value: '',
                unit: '个'
            },
            {
                code: 'supplierDelegateCount',
                label: '司机委派函',
                auth: '/index-srm-150',
                value: '',
                unit: '个'
            },
            {
                code: 'driverExpenseManage',
                label: '司机运费',
                auth: '/index-srm-150',
                value: '0',
                unit: '个'
            }
        ]
    },
    {
        label: '财务待办',
        code: FINANCETODO,
        iconClass: 'finance-icon',
        isRemove: true,
        type: 'todo',
        auth: '',
        childList: [
            {
                code: 'checkFee',
                label: '费用核对',
                auth: '/index-bms-180',
                value: '0',
                unit: '个',
                pageParams: {
                    path: '/bms/cost',
                    query: {
                        status: '30',
                        from: 'todoList'
                    }
                }
            },
            {
                code: 'checkBill',
                label: '账单核对',
                auth: '/index-bms-180',
                value: '0',
                unit: '个',
                pageParams: {
                    path: '/bms/bill',
                    query: {
                        billStatus: '30',
                        from: 'todoList'
                    }
                }
            },
            {
                code: 'settlementApply',
                label: '结算申请',
                auth: '/index-bms-180',
                value: '0',
                unit: '个',
                pageParams: {
                    path: '/bms/settle',
                    query: {
                        status: '10,47',
                        from: 'todoList'
                    }
                }
            },
            {
                code: 'invoiceManagement',
                label: '发票管理',
                auth: '/index-bms-180',
                value: '0',
                unit: '个',
                pageParams: {
                    path: '/bms/invoiceManage',
                    query: {
                        makeInvoiceStatuses: '60,90',
                        from: 'todoList'
                    }
                }
            },
            {
                code: 'dealingsCheckBill',
                label: '往来对账单',
                auth: '/index-bms-180',
                value: '0',
                unit: '个',
                pageParams: {
                    path: '/bms/statement',
                    query: {
                        accountMode: 'A',
                        dealingsBillStatus: '20,30,50',
                        from: 'todoList'
                    }
                }
            },
            {
                code: 'noTaxDebtProof',
                label: '无欠税证明',
                auth: '/index-bms-180',
                value: '0',
                unit: '个',
                pageParams: {
                    path: '/bms/noTaxDebtProof',
                    query: {
                        from: 'todoList',
                        taskStatus: 'UN_SUBMIT'
                    }
                }
            }
        ]
    },
    // {
    //     label: "运作待办",
    //     code: "operateTodo",
    //     iconClass: "operate-icon",
    //     isRemove: true,
    //     type: "todo",
    //      auth: "",
    //     childList: [
    //         {
    //             code: "1",
    //             label: "费用核对",
    //             auth: "/index-80",
    //             value: "3",
    //             unit: "个"
    //         },
    //         {
    //             code: "2",
    //             label: "账单核对",
    //             auth: "/index-80",
    //             value: "3",
    //             unit: "个"
    //         },
    //         {
    //             code: "3",
    //             label: "结算申请",
    //             auth: "/index-80",
    //             value: "3",
    //             unit: "个"
    //         },
    //         {
    //             code: "4",
    //             label: "发票管理",
    //             auth: "/index-80",
    //             value: "14",
    //             unit: "个"
    //         },
    //         {
    //             code: "5",
    //             label: "往来对账单",
    //             auth: "/index-80",
    //             value: "99",
    //             unit: "个"
    //         }
    //     ]
    // },
    {
        label: '运作待办',
        code: 'operateTodo',
        iconClass: 'operate-icon',
        isRemove: true,
        type: 'todo',
        auth: '',
        childList: [
            {
                code: 'dispatchCreateCount',
                label: '待调车',
                auth: '/index-tms-110',
                value: '0',
                unit: '个'
            },
            {
                code: 'dispatchLoadedCount',
                label: '待发车',
                auth: '/index-tms-110',
                value: '0',
                unit: '个'
            },
            {
                code: 'oneTheWayCount',
                label: '待抵达',
                auth: '/index-tms-110',
                value: '0',
                unit: '个'
            },
            {
                code: 'unUploadedCount',
                label: '待上传回单',
                auth: '/index-tms-110',
                value: '0',
                unit: '个'
            }
        ]
    },
    {
        label: '绩效待办',
        code: 'achievementsTodo',
        iconClass: 'achievements-icon',
        isRemove: true,
        type: 'todo',
        auth: '',
        childList: [
            // {
            //     code: "1",
            //     label: "罚扣款",
            //     auth: "/index-80",
            //     value: "3",
            //     unit: "个"
            // },
            {
                code: 'supplierCodeCount',
                label: '仲裁',
                auth: '/index-ams-100',
                value: '0',
                unit: '个'
            },
            {
                code: 'waitSupplierConfirmCount',
                label: '月度绩效',
                auth: '/index-srm-101',
                value: '',
                unit: '个'
            }
        ]
    }
];
